exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".cutting-line {\n  margin-bottom: 10px;\n  clear: both;\n  padding: 0;\n}\n.cutting-line .tilte {\n  display: inline-block;\n  vertical-align: middle;\n  font-size: 16px;\n  position: relative;\n  line-height: 40px;\n  padding: 0 20px;\n  text-align: center;\n  list-style: none;\n  color: #000;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"importLoaders":1,"modules":false,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./~/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./~/less-loader/dist/cjs.js?{"modifyVars":{"@primary-color":"#0070C2","@font-size-base":"12px","@primary-1 ":"#f2f2f2"}}!./src/components/CuttingLine/index.less
// module id = 1238
// module chunks = 0